import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/secure-sign/headerRightBg.png';
import headerRightBg375 from '../images/secure-sign/headerRightBg375.png';
import TabletContractManWoman from '../images/secure-sign/TabletContractManWoman.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import ComputerKeyPhone from '../images/secure-sign/ComputerKeyPhone.svg';
import ChipCircuitBoard from '../images/secure-sign/ChipCircuitBoard.svg';
import Diamond from '../images/secure-sign/Diamond.svg';
import BasketPaperStacks from '../images/secure-sign/BasketPaperStacks.svg';
import WantToSeeHow from '../components/WantToSeeHow';
import FinancialInstitutions from '../components/FinancialInstitutions';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const SecureSignHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `80px`, paddingBottom: `40px`}}>
		<h1>SecureSign</h1>
		<p>Safe and convenient<br />electronic signatures</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 70%;
		margin-top: 1em;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-top: 0;
			margin-bottom: 3em;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 484px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
			margin-bottom: 2em;
		}
	}
`;

const TabletContractManWomanFigure =
	<HeaderBottomContentFigure>
		<TabletContractManWoman alt='Man at desk looking at connected apps' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const SecureSignPage = (props: any) => {
	return (
	<Layout
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'150% 100%'}
		headerSplashBgPosition={'center bottom'}

		headerSplashBg={headerRightBg}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPositionLarge={'center bottom'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={TabletContractManWomanFigure}
		headerContentClass={'product'}
		headerContent={SecureSignHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='SecureSign - Digital signatures '
		metaDescription={'Expedite the lending process with our white label digital signature solution so your customers are free to sign wherever life takes them.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'450px'}
		BodyClass={'SecureSign'}
	>
		<ProblemSolution
			problem={'Requiring paper-based, wet signatures inconveniences customers and could prevent them from physically coming in-branch to sign. In addition, mailing physically signed agreements is costly and time-consuming.'}
			solution={"SecureSign's legally binding e-sign process eliminates the need for time-consuming in-person closing appointments, freeing up customers to sign at their leisure."}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#5cd3f2'}

			leftIcon = {<ComputerKeyPhone alt='phone, computer and key icon' style={{margin: `5px 0`}} />}
			leftHeading = {'Two-factor\nauthentication'}
			leftText={'Maximize data protection and login security.'}

			middleIcon = {<ChipCircuitBoard alt='chip on circuit board icon' style={{margin: `5px 0`}} />}
			middleHeading = {'Embedded\nelectronic signatures'}
			middleText = {'Increase customer satisfaction with a user-friendly process.'}

			rightIcon = {<Diamond alt='diamond icon' style={{margin: `0px 0`}} />}
			rightHeading = {'White label\nsolution'}
			rightText = {'Ensure a branded customer experience.'}
		/>
		<div className='centeredWrapper'>
			<Section className='leave-your-pen row row-flush centered'>
				<article className='col-12 col-md-6 '>
					<div className='product text-box'>
						<header>
							<h2>Leave your pen and paper behind</h2>
						</header>
						<p>Wet signatures are an enormous strain for financial institutions, and they present roadblocks for customers when closing. Challenge the status quo and go green with secure, paperless transactions.</p><p>Ensure brand recognition and increase conversion rates with a white label electronic signature flow that customers can utilize from the comfort of their home.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6 left-on-desktop' style={{paddingTop: `0`, paddingBottom: `1em`}}>
					<BasketPaperStacks alt='basket with stacks of paper' />
				</figure>
			</Section>
			<FinancialInstitutions />
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default SecureSignPage;
